export const categoryChoices = [
  { id: 'help', name: 'Ayuda' },
  { id: 'info', name: 'Info' },
];
